// 게이트웨이 로그아웃 절차 — AppSidebar 의 로그아웃 본문을 그대로 옮겼다.
// 임베드 실패 카드의 «다시 로그인»(lib/embedAuth relogin)도 같은 절차를 탄다.
// 이동(/login)은 호출부가 한다 — 사이드바는 navigate, 라우터 밖 화면은 location.assign.
import { sessionAPI, markLoggedOut, notifySessionChange } from '../api/client';
import { unsubscribeCurrentBrowser } from '../utils/push';
import { clearRecordedNcStorage } from './ncStorageRecord';

// 로그아웃 시 게이트웨이 토큰뿐 아니라 임베드된 메신저(MM)·드라이브(NC) 세션도 함께 종료(잔존 세션 방지).
export async function logoutGateway() {
  // 🔴 서버 응답을 기다리기 **전에** 로컬 자격증명부터 지운다. 응답이 안 오는 회선에서
  //    await 가 매달리면 '로그아웃을 눌렀는데 토큰이 그대로 남는' 공용기기 사고가 난다.
  // 🔴 로그아웃 표식은 localStorage 라 다른 탭·재로딩에서도 resume 이 막힌다
  //    (sessionStorage 였다면 새 탭이 방금 로그아웃한 계정으로 자동 재로그인된다).
  if (typeof markLoggedOut === 'function') markLoggedOut();
  // 인증 키만 제거(#111): localStorage.clear()는 '다시 열지 않기'(dismissedGlobalAnnsPersist)·
  // 사이드바 폭/뷰 등 UI 설정까지 지워 재로그인 시 공지 재노출·설정 초기화를 유발했음.
  // 인증 토큰/유저만 제거(api/client.js·App.jsx의 401 처리와 동일 방식), 나머지 설정은 보존.
  // 메일(RC) 세션 해제는 Bearer 가 필요하다 — 지우기 전에 잡아 둔다(#2688).
  const tokenAtLogout = localStorage.getItem('token');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  if (typeof notifySessionChange === 'function') notifySessionChange();
  try {
    // 🔴 축을 모두 끊는다 — 게이트웨이 세션 + 메신저(MM) + 드라이브(NC) + 메일(RC · 그 계정의 모든 기기).
    //    게이트웨이 폐기는 refresh 쿠키만으로 동작하므로 토큰을 이미 지운 뒤여도 된다
    //    (backend/routers/session.py:241-244). 5초 상한은 sessionAPI 가 갖고 있다.
    // 이 브라우저의 웹 푸시 구독도 끊는다(공용 PC 에 알림이 계속 오는 것 방지). 브라우저 쪽만 끊고
    // 서버 알림 설정은 그대로 둔다 → 다시 로그인하면 자동 재구독된다(utils/push.js). 3초 상한.
    await Promise.allSettled([
      (sessionAPI && typeof sessionAPI.logout === 'function') ? sessionAPI.logout() : Promise.resolve(),
      fetch('/mm/api/v4/users/logout', { method: 'POST', credentials: 'include' }),
      fetch('/drive/index.php/logout', { method: 'GET', credentials: 'include', redirect: 'manual' }),
      // 메일(RC) 세션 — 서버가 그 계정의 RC 세션을 지운다(#2688). 토큰은 지우기 전에 잡아 둔 값이다.
      tokenAtLogout
        ? fetch('/api/mail2/logout', { method: 'POST', credentials: 'include', headers: { Authorization: 'Bearer ' + tokenAtLogout } })
        : Promise.resolve(),
      (typeof unsubscribeCurrentBrowser === 'function') ? unsubscribeCurrentBrowser() : Promise.resolve(),
    ]);
  } catch (e) { /* 베스트에포트 — 실패해도 로컬 로그아웃은 이미 끝났다 */ } finally {
    // 🔴 NC 로그아웃 fetch 는 NC 문서를 띄우지 않아 NC 의 clear 코드가 돌지 않는다(Clear-Site-Data 는 nginx 가 뗀다) —
    //    NC 가 쓴 키는 여기서 지운다. 성공·실패와 무관하다(lib/ncStorageRecord).
    clearRecordedNcStorage();
  }
}
